export default IconNumber20Small => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-number-20-small" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z" />
  <path d="M6 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3" />
</svg>`;